import MutualFundAllTransactionsActions from "@redux/feature/ActivityBook/OrderBook/MutualFund/actions/MutualFundAllTransactions";
import MutualFundSIP_STP_SWP_Transactions from "@redux/feature/ActivityBook/OrderBook/MutualFund/actions/MutualFundSIP_STP_SWP_Transactions";
import OrderbookMutualFundCommonTransactions from "@redux/feature/ActivityBook/OrderBook/MutualFund/actions/OrderbookMutualFundCommonTransactions";
import MutualFundMandateTransactions from "@redux/feature/ActivityBook/OrderBook/MutualFund/actions/MutualFundMandateTransactions";
import OrderbookTransferInActions from "@redux/feature/ActivityBook/OrderBook/MutualFund/actions/OrderbookTransferIn";
export default (function () {
    return {
        mutualFunds: {
            orderbookAllTransactions: new MutualFundAllTransactionsActions(),
            orderbookSummaryTransaction: new MutualFundSIP_STP_SWP_Transactions(),
            orderbookMutualFundTransactionsCommon: new OrderbookMutualFundCommonTransactions(),
            mandateTransaction: new MutualFundMandateTransactions(),
            orderbookTransferIn: new OrderbookTransferInActions(),
        },
    };
});
